import { render } from "./componentTakePhoto.vue?vue&type=template&id=71ff03fa"
import script from "./componentTakePhoto.vue?vue&type=script&lang=js"
export * from "./componentTakePhoto.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__